module.exports = __webpack_public_path__ + "static/media/9-5.b8b2ec98.mp3";